import Axios from "axios";
import { handleApiError, handleRequest, handleResponse } from "./ClientHelper";

export function axiosClient(baseURL: string) {
  const clientInstance = Axios.create({ baseURL });

  clientInstance.interceptors.request.use(handleRequest);
  clientInstance.interceptors.response.use(handleResponse, handleApiError);

  return clientInstance;
}
